// tienda/BeneficiosSection.jsx

import React from "react";
import { motion } from "framer-motion";
import { MapPin, MessageSquare, HandCoins, Clock, Truck, PhoneCall } from "lucide-react";
import { brand, fadeUp } from "../shared/brand";

const ITEMS = [
  { icon: <MapPin className="size-5"/>,        title: "Seguimiento en vivo",  text: "Tú y tus clientes saben dónde está cada pedido, en todo momento." },
  { icon: <MessageSquare className="size-5"/>, title: "Mensajes automáticos", text: "WhatsApp en cada hito del proceso, sin escribir manualmente." },
  { icon: <HandCoins className="size-5"/>,     title: "Pago contraentrega",   text: "Cobranza segura, depositamos lo recaudado directamente a tu cuenta." },
  { icon: <Clock className="size-5"/>,         title: "Mismo día",            text: "Pedidos hasta 11:00 AM → entregados antes de 8:00 PM." },
  { icon: <Truck className="size-5"/>,         title: "Tarifa fija Lima",     text: "El costo más bajo del mercado. Sin sorpresas ni cobros extras." },
  { icon: <PhoneCall className="size-5"/>,     title: "Soporte ágil",         text: "Acompañamiento real cuando lo necesitas, no un bot." },
];

export function BeneficiosSection() {
  return (
    <section id="beneficios" className="border-b border-slate-100 bg-white scroll-mt-16">
      <div className="mx-auto max-w-7xl px-4 py-12 md:py-16">
        <motion.h2 {...fadeUp} className="text-2xl md:text-3xl font-extrabold mb-8" style={{ color: brand.primary }}>
          Beneficios clave
        </motion.h2>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {ITEMS.map(b => (
            <motion.div key={b.title} {...fadeUp} className="rounded-2xl border border-slate-100 bg-slate-50 p-5">
              <div className="flex items-start gap-3">
                <div
                  className="mt-0.5 grid size-10 place-items-center rounded-xl shrink-0"
                  style={{ background: brand.primary + "12", color: brand.primary }}
                >
                  {b.icon}
                </div>
                <div>
                  <h3 className="text-sm font-bold text-slate-800">{b.title}</h3>
                  <p className="mt-1 text-xs text-slate-500 leading-relaxed">{b.text}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}